import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import getDividerClassNames from "./getDividerClassNames";
import getFlexClassNames from "./getFlexClassNames";
import getMarginClassNames from "./getMarginClassNames";
import getPaddingClassNames from "./getPaddingClassNames";
import { AlignStatus } from "../Align";
import { getAlignItemsForOrigin } from "../Align/AlignBox";

var Box = function Box(props) {
  var children = props.children,
      className = props.className,
      background = props.background,
      boxRef = props.boxRef,
      divider = props.divider,
      flex = props.flex,
      flexBasis = props.flexBasis,
      flexGrow = props.flexGrow,
      flexShrink = props.flexShrink,
      hideIfEmpty = props.hideIfEmpty,
      margin = props.margin,
      padding = props.padding,
      style = props.style,
      remaining = _objectWithoutProperties(props, ["children", "className", "background", "boxRef", "divider", "flex", "flexBasis", "flexGrow", "flexShrink", "hideIfEmpty", "margin", "padding", "style"]);

  var marginMap = typeof margin === 'number' ? {
    all: margin
  } : margin;
  var paddingMap = typeof padding === 'number' ? {
    all: padding
  } : padding;
  var classes = classNames(className, 'Box-root', hideIfEmpty ? 'Box-hideIfEmpty' : null, background ? "Box-background--".concat(background) : null, divider ? getDividerClassNames(divider) : null, marginMap ? getMarginClassNames(marginMap) : null, paddingMap ? getPaddingClassNames(paddingMap) : null);

  var styleValue = _objectSpread({}, style);

  if (flexBasis != null) {
    styleValue.flexBasis = "".concat(flexBasis);
  }

  if (flexGrow != null) {
    styleValue.flexGrow = "".concat(flexGrow);
  }

  if (flexShrink != null) {
    styleValue.flexShrink = "".concat(flexShrink);
  }

  if (!flex) {
    return /*#__PURE__*/React.createElement("div", _extends({}, remaining, {
      ref: boxRef,
      className: classes,
      style: styleValue
    }), children);
  }

  return /*#__PURE__*/React.createElement(AlignStatus, null, function (_ref, isAligned) {
    var origin = _ref.origin;
    var alignFlex = flex; // Set the default value for align-items for aligned boxes with
    // flex-direction: row.

    if (flex && isAligned) {
      // 'row' is the default value for flex-direction.
      var defaultAlignItems = getAlignItemsForOrigin(origin);

      if (typeof flex === 'boolean') {
        alignFlex = {
          alignItems: defaultAlignItems
        };
      } else if (flex.direction !== 'column') {
        alignFlex = _objectSpread({}, flex, {
          alignItems: flex.alignItems ? flex.alignItems : defaultAlignItems
        });
      }
    }

    classes = classNames(classes, alignFlex ? getFlexClassNames(alignFlex) : null);
    return /*#__PURE__*/React.createElement("div", _extends({}, remaining, {
      ref: boxRef,
      className: classes,
      style: styleValue
    }), children);
  });
};

export default Box;